"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _coreThemes = require("@legacy-vfuk/core-themes");

var _coreSimpleGrid = _interopRequireDefault(require("@legacy-vfuk/core-simple-grid"));

var _coreMatchMedia = require("@legacy-vfuk/core-match-media");

var _coreBaseProps = require("@legacy-vfuk/core-base-props");

var _StandardBanner = _interopRequireDefault(require("./themes/StandardBanner.theme"));

var Styled = _interopRequireWildcard(require("./styles/StandardBanner.style"));

var _ImageContainer = _interopRequireDefault(require("./components/ImageContainer"));

var _ContentWrapper = _interopRequireDefault(require("./components/ContentWrapper"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var StandardBanner = function StandardBanner(_ref) {
  var _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
      _ref$contentAlignment = _ref.contentAlignment,
      contentAlignment = _ref$contentAlignment === void 0 ? 'left' : _ref$contentAlignment,
      _ref$contentSize = _ref.contentSize,
      contentSize = _ref$contentSize === void 0 ? 1 : _ref$contentSize,
      heading = _ref.heading,
      paragraph = _ref.paragraph,
      dateCountdown = _ref.dateCountdown,
      primaryButton = _ref.primaryButton,
      secondaryButton = _ref.secondaryButton,
      footnote = _ref.footnote,
      backgroundColor = _ref.backgroundColor,
      backgroundImage = _ref.backgroundImage,
      primaryImage = _ref.primaryImage,
      secondaryImage = _ref.secondaryImage,
      localTheme = _ref.localTheme,
      id = _ref.id,
      dataSelectorPrefix = _ref.dataSelectorPrefix,
      dataAttributes = _ref.dataAttributes;
  var componentName = 'StandardBanner';
  var standardBannerTheme = (0, _coreThemes.useLocalTheme)(componentName, _StandardBanner["default"], localTheme);

  var _useBreakpoints = (0, _coreMatchMedia.useBreakpoints)(),
      mdAndBelow = _useBreakpoints.mdAndBelow;

  var getLgLayout = function getLgLayout() {
    if (contentSize === 2) return [6, 6];
    if (contentSize === 3) return [7, 5];
    return [5, 7];
  };

  var contentHeight = {
    sm: 280,
    md: 264,
    lg: 496
  };
  var imageHeight = {
    sm: 188,
    md: 472,
    lg: 496
  };
  var gridSpacing = mdAndBelow ? 0 : 4;
  return /*#__PURE__*/_react["default"].createElement(Styled.FullWidthContainer, _extends({
    standardBannerTheme: standardBannerTheme,
    appearance: appearance,
    id: id,
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix),
    "data-component-name": componentName
  }, dataAttributes), /*#__PURE__*/_react["default"].createElement(Styled.StandardBanner, {
    contentAlignment: contentAlignment
  }, /*#__PURE__*/_react["default"].createElement(_coreSimpleGrid["default"], {
    layout: {
      sm: [12],
      lg: getLgLayout()
    },
    spacing: gridSpacing
  }, /*#__PURE__*/_react["default"].createElement(_ContentWrapper["default"], {
    appearance: appearance,
    localTheme: standardBannerTheme,
    heading: heading,
    paragraph: paragraph,
    primaryButton: primaryButton,
    secondaryButton: secondaryButton,
    dateCountdown: dateCountdown,
    footnote: footnote,
    contentSize: contentSize,
    contentHeight: contentHeight,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'content')
  }), /*#__PURE__*/_react["default"].createElement(_ImageContainer["default"], {
    contentAlignment: contentAlignment,
    backgroundColor: backgroundColor,
    backgroundImage: backgroundImage,
    primaryImage: primaryImage,
    secondaryImage: secondaryImage,
    contentSize: contentSize,
    imageHeight: imageHeight,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'image')
  }))));
};

StandardBanner.displayName = "StandardBanner";
var _default = StandardBanner;
exports["default"] = _default;
//# sourceMappingURL=StandardBanner.js.map